<template>
    <div
        :class="'w-90 d-flex flex-row justify-center align-center note-content pa-3 mx-3 border-radius-0 mb-4 '"
    >
        <div class="w-90 d-flex flex-row justify-space-between align-center" @click="setPage">
            <span class="primary--text d-inline-block font-size-14">{{ note_data.content }}</span>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex'

export default {
    props: {
        note_data: { type: Object, default: null },
    },
    data() {
        return {
            loading: false,
        }
    },
    computed: {
        ...mapState({
            currentStage: (state) => state.bookReading.currentStage,
            currentPage: (state) => state.bookReading.currentPage,
            currentChapter: (state) => state.bookReading.currentChapter,
            currentChapterData: (state) => state.bookReading.currentChapterData,
            bookUserNotes: (state) => state.bookReading.bookUserNotes,
        }),
    },
    methods: {
        ...mapActions('bookReading', [
            'setCurrentPage',
            'setCurrentChapter',
            'setCurrentChapterData',
            'hideAllUtils',
            'setBookUserNotes',
        ]),
        setPage() {
            window.scrollTo(0, 0)
            let chapterHtml = document.querySelector(`#chapter_${this.currentChapter}`)
            if (chapterHtml) chapterHtml.style.display = 'none'

            let bookPage = document.querySelector(`#bookpage_${this.currentPage}`)
            if (bookPage) bookPage.style.display = 'none'

            this.setCurrentChapter(this.note_data.bookChapter.chapterNumber)
            this.setCurrentPage(this.note_data.page)

            chapterHtml = document.querySelector(`#chapter_${this.currentChapter}`)
            if (chapterHtml) chapterHtml.style.display = 'block'

            const currentPage = document.querySelector(`.current-page`)
            if(currentPage) currentPage.classList.toggle('current-page')

            bookPage = document.querySelector(`#bookpage_${this.currentPage}`)
            if (bookPage) {
                bookPage.style.display = 'flex'
                bookPage.classList.toggle('current-page')
            }

            this.setCurrentChapterData(this.note_data.bookChapter)
            this.hideAllUtils()
        },
    },
}
</script>

<style>
.note-content:hover {
    cursor: pointer;
    background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.1)) !important;
    border-radius: 2px;
}
.note-content {
    /* border: 1.5px solid #514773 !important; */
    border-radius: 2px;
    background: #cae4e3;
    color: #514773;
    background-image: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0)) !important;
    transition: background-image 0.5s ease;
}

.chapter-active {
    border: 1.5px solid #514773 !important;
    background: #514773 !important;
    color: white !important;
}
</style>
